export default function IosTennisball() {
  return (
    <div
      className="ion-icon-ios-tennisball"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M48.05,251.556c-0.001,0.039-0.003,0.077-0.004,0.116c0,0,0.002,0,0.003,0C48.049,251.634,48.049,251.595,48.05,251.556z"
		/>
	<path d="M260.311,463.915c0.066-0.002,0.133-0.006,0.199-0.007c-0.066,0.001-0.133,0.001-0.199,0.004
		C260.311,463.912,260.311,463.913,260.311,463.915z"/>
	<path d="M256,48.001c-2.586,0-5.29,0.064-7.852,0.158L248,48.153c0,0.003,0,0.004,0,0.006c-5,0.199-10,0.602-16,1.205
		c0-0.002,0-0.004,0-0.008c0,0.005,0.083,0.008,0.072,0.012c-96.974,11.061-173.654,88.975-183.13,186.41
		c-0.004,0.018,0.045,0.222,0.042,0.222c0.003,0,0.004,0,0.007,0c-0.513,5-0.826,10-0.936,16c-0.001,0-0.003,0-0.004,0l0.003-0.152
		c-0.028,1.43-0.054,2.777-0.054,4.215c0,114.852,92.977,207.938,207.841,207.938c6.856,0,14.159-0.383,20.159-1.031
		c0,0.002,0,0.006,0,0.006c0-0.004,0.213-0.008,0.24-0.014c97.436-9.486,175.247-86.086,186.312-183.036
		c0.004-0.014,0.088,0.074,0.092,0.074c-0.002,0-0.006,0-0.008,0c0.889-8,1.363-15.859,1.363-23.904
		C464,141.245,370.87,48.001,256,48.001z M130.63,266.853c-20.895-8.474-42.788-13.43-65.244-14.816
		c0.11-5.374,0.438-10.695,0.986-15.952c52.568,3.275,104.203,24.977,144.375,65.146c40.172,40.169,61.876,91.797,65.152,144.359
		c-5.257,0.548-10.579,0.876-15.954,0.985c-1.385-22.453-6.342-44.344-14.816-65.236c-10.459-25.79-25.834-48.937-45.696-68.795
		C179.572,292.684,156.423,277.311,130.63,266.853z M297.722,214.265c-40.964-40.959-62.731-93.835-65.332-147.467
		c5.25-0.652,10.568-1.08,15.941-1.293c1.073,23.65,6.105,46.702,15.007,68.654c10.461,25.79,25.835,48.936,45.696,68.795
		c19.862,19.859,43.01,35.232,68.803,45.691c21.954,8.901,45.008,13.933,68.66,15.007c-0.213,5.37-0.643,10.689-1.293,15.939
		C391.564,276.989,338.686,255.225,297.722,214.265z"/>
</g>
</svg>
`,
      }}
    />
  )
}
